const canUpdate = ( thing ) =>
    thing.isProxy &&
    thing.isUpdated &&
    thing.isShowingOriginalData && ! thing.isShowingOriginalData();

export default canUpdate;